import { render, staticRenderFns } from "./SchemaEdit.vue?vue&type=template&id=6051427e"
import script from "./SchemaEdit.vue?vue&type=script&lang=ts"
export * from "./SchemaEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports